export const SECONDARY_BUTTON_BASE_CSS_VARS = {
  "theme-website-secondary-button-default-text-color":
    "var(--theme-website-color-5)",
  "theme-website-secondary-button-hover-text-color":
    "var(--theme-website-color-6)",
  "theme-website-secondary-button-default-background-color":
    "var(--theme-website-color-1)",
  "theme-website-secondary-button-hover-background-color":
    "var(--theme-website-color-2)",
  "theme-website-secondary-button-default-border-color":
    "var(--theme-website-color-border)",
  "theme-website-secondary-button-hover-border-color":
    "var(--theme-website-color-border)",
  "theme-website-secondary-button-default-font-family": "InterVariable",
  "theme-website-secondary-button-hover-font-family": "InterVariable",
  "theme-website-secondary-button-default-font-weight": "500",
  "theme-website-secondary-button-hover-font-weight": "500",
  "theme-website-secondary-button-default-font-size": "1rem",
  "theme-website-secondary-button-hover-font-size": "1rem",
  "theme-website-secondary-button-default-line-height": "1.5",
  "theme-website-secondary-button-hover-line-height": "1.5",
  "theme-website-secondary-button-default-letter-spacing": "-0.01em",
  "theme-website-secondary-button-hover-letter-spacing": "-0.01em",
  "theme-website-secondary-button-default-border-width": "1px",
  "theme-website-secondary-button-hover-border-width": "1px",
  "theme-website-secondary-button-padding-top": "12",
  "theme-website-secondary-button-padding-bottom": "12",
  "theme-website-secondary-button-padding-left": "24",
  "theme-website-secondary-button-padding-right": "24",
  "theme-website-secondary-button-default-shadow": "none",
  "theme-website-secondary-button-hover-shadow": "none",
  "theme-website-secondary-button-default-border-left-top-radius": "30",
  "theme-website-secondary-button-hover-border-left-top-radius": "30",
  "theme-website-secondary-button-default-border-left-bottom-radius": "30",
  "theme-website-secondary-button-hover-border-left-bottom-radius": "30",
  "theme-website-secondary-button-default-border-right-top-radius": "30",
  "theme-website-secondary-button-hover-border-right-top-radius": "30",
  "theme-website-secondary-button-default-border-right-bottom-radius": "30",
  "theme-website-secondary-button-hover-border-right-bottom-radius": "30",
};
